import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BaseStoreFacade } from '@city/data-access';
import { ProductRecommendationService } from '@product/data-access/v2';
import { map, Observable, tap } from 'rxjs';

export const productRecommendationResolver: ResolveFn<null> = (): Observable<null> => {
  const baseStoreFacade = inject(BaseStoreFacade);
  const productRecommendationService = inject(ProductRecommendationService);

  return baseStoreFacade.getActiveCode().pipe(
    tap((baseStoreCode) => productRecommendationService.loadProductRecommendation(baseStoreCode)),
    map(() => null),
  );
};
